import { AuthSystemRole } from 'providers/auth.service';
import { toTitleCase } from './toTitleCase';

export function translateSystemRole(role: AuthSystemRole | string) {
    let name: string;

    switch (role) {
        case 'default':
            name = 'Default';
            break;
        case 'maintenance':
            name = 'Service';
            break;
        case 'readonly':
            name = 'Read only';
            break;
        case 'systemAdmin':
            name = 'System admin';
            break;
        case 'orgAdmin':
            name = 'Organization admin';
            break;
        case 'chargerDiagnostics':
            name = 'Charger diagnostics';
            break;
        default:
            name = toTitleCase(role);
            break;
    }

    return name;
}

export function translateSystemRoles(roles: AuthSystemRole[] | string[] | string): string {
    const names: string[] = [];
    if (typeof roles === 'string') {
        roles = [roles];
    }
    for (const role of roles) {
        names.push(translateSystemRole(role));
    }

    return names.join(', ');
}
